var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12354 3.23725C1.12354 2.55393 1.67747 2 2.36078 2H19.3853C20.0686 2 20.6225 2.55393 20.6225 3.23724V12.1454H20.1276V3.23724C20.1276 2.82726 19.7953 2.4949 19.3853 2.4949H2.36078C1.95079 2.4949 1.61843 2.82726 1.61843 3.23725V25.0128C1.61843 25.4227 1.95079 25.7551 2.36078 25.7551H20.3751V26.25H2.36078C1.67747 26.25 1.12354 25.6961 1.12354 25.0128V3.23725Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5244 8.1863H8.02234V7.69141H17.5244V8.1863Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5244 12.1453H8.02234V11.6504H17.5244V12.1453Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5244 16.1045H8.02234V15.6096H17.5244V16.1045Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1221 8.1863H3.27148V7.69141H6.1221V8.1863Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1221 12.1453H3.27148V11.6504H6.1221V12.1453Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1221 16.1045H3.27148V15.6096H6.1221V16.1045Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7236 20.0637H8.02234V19.5688H13.7236V20.0637Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1261 12.1454L17.5245 20.0638L17.1818 19.7068L24.7834 11.7884L25.1261 12.1454Z",
    fill: "#2D2943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6245 21.0537L16.5747 20.0639L16.9175 20.4209L15.9673 21.4107L15.6245 21.0537Z",
    fill: "#2D2943"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2756 11.1556L22.2756 4.22705L22.7705 4.22705L22.7705 11.1556L22.2756 11.1556Z",
    fill: "#2D2943"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2756 24.0231L22.2756 17.0945L22.7705 17.0945L22.7705 24.0231L22.2756 24.0231Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeases);
export default __webpack_public_path__ + "static/media/leases.d606c6dc.svg";
export { ForwardRef as ReactComponent };